import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const VoiceProvider = lazy(()=> import(/* webpackChunkName: "Voice Provider" */'./components'));

const routes = () => (
    <PrivateRoute exact path="/settings/voice-provider" component={VoiceProvider} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/VoiceProvider/routes.js